module.exports = __webpack_public_path__ + "static/media/tick.474aae47.svg";